export class MeurhAdmissoesObservacoesFormController implements ng.IController {

    static $inject = [];

    public entity: any;

    constructor() {/**/}
}
